// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"51135c50","172":"07184f18","237":"80ba70b0","277":"4cf45d02","330":"9a85f2d0","488":"4239f3dc","538":"48e36e97","557":"ac0b6ec3","593":"84042969","900":"543a4917"}[chunkId] + ".chunk.js";
};